<div class="files-preview-container" [class.disabled]="isDisabled || isViewer">

  <div class="dnd-container"
    *ngIf="!isViewer"
    appDnd
    [class.loading]="loading"
    [hidden]="!docsEditable"
    (fileDropped)="onFileDropped($event)"
  >
    <input #fileDropRef (change)="fileBrowseHandler($event)"
      [attr.id]="'fileDropRef_' + managerIndex"
      [disabled]="isDisabled" multiple type="file"
      [accept]="AcceptedExtentions" />
    <div class="dnd-wrapper" [ngClass]="{'flexing': differentStyle}">
      <div class="icon">
        <img *ngIf="type == 'video'" src="assets/images/icons/ic-video.svg" alt="">
        <img *ngIf="type != 'video'" src="assets/images/icons/ic-file.svg" alt="">
      </div>
     <div>
       <div class="head" [ngStyle]="{'display' : differentStyle ? 'flex': ''}">
        <div>
          <b>{{('fileManager.' + (type == 'video' ? 'Drag and drop your video file here' : 'Drag and drop the file here')) | translate }}</b>
        </div>
        <div class="or">
          <b>
            <span>{{'fileManager.Or' | translate}} </span>
            <label [attr.for]="'fileDropRef_' + managerIndex">
              {{"fileManager.Select file" | translate}}
            </label>
          </b>
        </div>
      </div>
      <div class="info">
        {{'fileManager.Supported files' | translate}}:
        <b class="text-uppercase">
          <ng-container *ngIf="allowedExt.length < 14">
            <span>{{allowedExtText}}</span>
          </ng-container>
          <span *ngIf="allowedExt.length == 14">PDF, DOC, JPG, PNG, ...</span>
        </b>
      </div>
      <div class="info">
        {{'fileManager.Maximum file size' | translate}}: <b>{{maxFileSize}} MB</b>
      </div>
      <div class="info" *ngIf="hint"><b>{{hint}}</b></div>
     </div>
    </div>
  </div>

  <div *ngIf="selectedfilesCount > maxFiles && maxFiles > 1" class="has-error">
    {{ 'fileManager.Maximum allowed files is' | translate: { maxFiles: maxFiles } }}
  </div>
  <div *ngIf="selectedfilesCount > maxFiles && maxFiles === 1" class="has-error">
    {{ 'fileManager.Only One File is allowed' | translate }}
  </div>
  <div *ngIf="!validFile" class="has-error">{{"fileManager.Invalid File Extensions" | translate}}</div>
  <div *ngIf="fileMaxSiZeErorr" class="has-error">{{ "fileManager.Max File Size" | translate: { maxFileSize: maxFileSize } }}</div>
  <div *ngIf="fileMaxDurationErorr" class="has-error">{{ "fileManager.Max Video duration" | translate: { max: maxDuration } }}</div>
  <div *ngIf="fileMaxNameSiZeErorr" class="has-error"></div>
  <div *ngIf="!(files && files?.length) && isRequired && isSubmitted" class="has-error">
    {{"form.required field" | translate}}
  </div>


  <div class="files-list" [class.mt-0]="isViewer">
    <div class="row">
      <div
        *ngFor="let file of files; let i = index"
        [ngClass]="{ 'col-md-6': cols == 2 }"
        class="col-12"
      >
        <div *ngIf="file" class="file-item">
          <div class="file-details">
            <div class="file-icon" *ngIf="fileExt(file.name)">
              <img src="./assets/images/file-icons/ic_{{fileExt(file.name)}}.svg" />
            </div>
            <div>
              <label [title]="fileName ? fileName : file?.name">{{ fileName ? fileName : file?.name }}</label>
              <span *ngIf="file?.size">{{ formatBytes(file?.size) }}</span>
            </div>
          </div>
          <div class="file-btn">
            @if (!isViewer) {
              <button
                type="button"
                *ngIf="!isDisabled"
                (click)="deleteFile(i, file.id)"
                class="btn-delete"
              >
                <svg width="14" height="18" viewBox="0 0 14 18" fill="none">
                  <path d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14M1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16Z" fill="#EB2E22"/>
                </svg>
              </button>
            }
            @if (isViewer || isDisabled) {
              <a [href]="file.path" [download]="file?.name" target="_blank" >
                <svg width="14" height="18" style="width: 0.9rem;" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6814 6.69027C13.8019 6.56272 13.7115 6.35294 13.536 6.35294H10.2C10.0895 6.35294 10 6.2634 10 6.15294V0.2C10 0.0895432 9.91046 0 9.8 0H4.2C4.08954 0 4 0.0895431 4 0.2V6.15294C4 6.2634 3.91046 6.35294 3.8 6.35294H0.463987C0.288548 6.35294 0.198123 6.56272 0.318584 6.69027L6.8546 13.6108C6.93352 13.6943 7.06648 13.6943 7.1454 13.6108L13.6814 6.69027ZM0.2 15.8824C0.0895426 15.8824 0 15.9719 0 16.0824V17.8C0 17.9105 0.0895431 18 0.2 18H13.8C13.9105 18 14 17.9105 14 17.8V16.0824C14 15.9719 13.9105 15.8824 13.8 15.8824H0.2Z" fill="#5252D8"/>
                </svg>
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
